import * as React from "react";
import axios, { AxiosResponse } from "axios";

interface ActionFetchState {
  loading: boolean;
  actions: Insite.API.Action[];
  error?: string;
}

export function useFetchActions(equipIds?: string[]) {
  const [actionsFetch, setActionsFetch] = React.useState<ActionFetchState>({
    loading: false,
    actions: [],
    error: undefined,
  });

  React.useEffect(
    function getActions() {
      try {
        if (equipIds === undefined || equipIds.length === 0) {
          setActionsFetch({
            ...actionsFetch,
            error: "Equip is undefined",
          });
          throw Error("Action Ids cannot be undefined");
        }
        setActionsFetch({
          ...actionsFetch,
          loading: true,
        });
        const fetchActions = async () => {
          const {
            data,
          }: AxiosResponse<{ [key: string]: Insite.API.Action[] }> =
            await axios.post("/v1/equips/actions", {
              equipIds,
            });

          // checking if the returned data is empty object
          if (Object.values(data).length === 0) {
            setActionsFetch({
              ...actionsFetch,
              loading: false,
              error: "No open actions for this equip",
            });
          } else {
            setActionsFetch({
              // The API will return a data structure like
              // {
              //   endpoint1: [...actions],
              //   endpoint2: [...actions]
              //   ...etc
              // }
              // The reason we only grab the first element here
              // is because for this particular components, we just
              // sent one equipId in the request for the modal,
              // so we expect to get only one property in the
              // response objet.
              actions: Object.values(data)[0],
              loading: false,
              error: undefined,
            });
          }
        };

        void fetchActions();
      } catch (error) {
        setActionsFetch({
          ...actionsFetch,
          loading: false,
          error,
        });
        console.error(error);
      }
    },
    [equipIds]
  );

  return actionsFetch;
}
